import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Button } from "components/ui/button";
import { setNextButtonClick } from "../../../../redux/slice/temporaryStorage/temporaryStorageSlice";
import PersonalDataStep from "../newBooking/PersonalDataStep";
import { useTemporaryStorageStepCounter } from "../hooks/useTemporaryStorageStepCounter";

/**
 * TemporaryStoragePersonalDataStep
 * ---------------------------------------------------------------
 * Step component for entering personal data during temporary storage flow.
 * 
 * @remarks
 * - Displays personal data form fields
 * - Handles loading and validation states
 * - Fixed bottom action button
 */
function TemporaryStoragePersonalDataStep() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { current, total } = useTemporaryStorageStepCounter("personalData");

  const { nextEnabled } = useSelector(
    (state: RootState) => state.bookingCreation
  );

  const handleClickNext = useCallback(() => {
    dispatch(setNextButtonClick());
  }, [dispatch]);

  return (
    <div className="flex flex-col justify-center items-center px-5">
      {/* Step Counter */}
      <p className="-mt-5 mb-6 text-xs text-muted-foreground text-center" role="status" aria-live="polite">
        {t("temporary_storage.new_booking.step_counter", {
          current,
          total,
          defaultValue: "Schritt {{current}} von {{total}}",
        })}
      </p>

      <PersonalDataStep />
      
      <div className="fixed flex w-full max-w-md px-5 left-0 right-0 items-center justify-center bottom-4 m-auto">
        <Button
          size="lg"
          variant="primary"
          className="w-full"
          onClick={handleClickNext}
          disabled={!nextEnabled}
        >
          {t("temporary_storage.new_booking.location.next_button_title")}
        </Button>
      </div>
    </div>
  );
}

export default memo(TemporaryStoragePersonalDataStep);
